import React from "react";
import PropTypes from "prop-types";
import styles from "assets/jss/material-dashboard-react/components/bieudo.js";
const useStyles = makeStyles(styles);
import { makeStyles } from "@material-ui/core/styles";
import { Chart } from "react-chartjs-2";
import {
  Chart as ChartJS,
  ArcElement,
  Tooltip,
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement,
  LineController,
  BarElement,
  BarController,
  Legend,
} from "chart.js";
ChartJS.register(
  ArcElement,
  Tooltip,
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement,
  LineController,
  BarElement,
  BarController,
  Legend
);
import Config from "conFig.js";
let options_thoigiantldv = {
  maintainAspectRatio: false,
  color: "#fff",
  responsive: true,

  tooltips: { mode: "index", intersect: false },
  hover: { mode: "nearest", intersect: true },
  scales: {
    yAxes: {
      type: "linear",
      position: "right",
      ticks: {
        color: "#fff",
      },
    },
    xAxes: {
      ticks: {
        color: "#00fff0",
      },
    },
  },
  plugins: {
    legend: {
      position: "bottom",
      display: true,
    },
  },
};
const Tyle = React.memo(function Tyle(props) {
  const classes = useStyles();
  const { thangnam } = props;
  const [tyle, setTyle] = React.useState(null);
  const [kehoach, setKehoach] = React.useState(null);
  const [thuchien, setThuchien] = React.useState(null);
  const [column, setColumn] = React.useState(null);
  var username = localStorage.getItem("username");
  const token = localStorage.getItem("token");
  var obj = {
    method: "GET",
    headers: {
      Accept: "application/json",
      "Content-Type": "application/json",
      Authorization: "Bearer " + token,
    },
  };
  const getdata = () => {
    var thang = String(thangnam.$M + 1).padStart(2, "0") + "/" + thangnam.$y;
    var tyletemp = [];
    var kehoachtemp = [];
    var thuchientemp = [];
    var columntemp = [];
    var url =
      Config.backend +
      "/api/DashBoard/dashbieudodvbaocao?thang=" +
      thang +
      "&username=" +
      username;
    fetch(url, obj)
      .then((res) => res.json())
      .then((data) => {
        if (data.length > 0) {
          data.map((prop) => {
            tyletemp.push(prop.tyle);
            kehoachtemp.push(prop.ts_donvi);
            thuchientemp.push(prop.dabaocao);
            columntemp.push(prop.maubaocao);
          });
          setTyle(tyletemp);
          setKehoach(kehoachtemp);
          setThuchien(thuchientemp);
          setColumn(columntemp);
          tyletemp = [];
          kehoachtemp = [];
          thuchientemp = [];
          columntemp = [];
        }
      })
      .catch((error) => {
        console.error("Error fetching data: ", error);
      });
  };
  const data_solieu = {
    labels: column,
    datasets: [
      {
        type: "line",
        label: "Tỷ lệ",
        fill: true,
        backgroundColor: "rgb(255, 99, 132)",
        borderColor: "#00ec00",
        data: tyle,
        yAxisID: "left-axis",
      },
      {
        label: "Kế hoạch",
        fill: true,
        backgroundColor: "#a0522d",
        borderColor: "#a0522d",
        data: kehoach,
      },
      {
        label: "Thực hiện",
        fill: true,
        backgroundColor: "#fff",
        borderColor: "#fff",
        data: thuchien,
      },
    ],
  };
  React.useEffect(() => {
    getdata();
  }, []);
  return (
    <div className={classes.chitieu_4_total} style={{ height: 180 }}>
      <Chart type="bar" data={data_solieu} options={options_thoigiantldv} />
    </div>
  );
});

Tyle.propTypes = {
  thangnam: PropTypes.object,
};
export default Tyle;
